import { render } from "./JobSeekerDetail.vue?vue&type=template&id=5f9ab0be&ts=true"
import script from "./JobSeekerDetail.vue?vue&type=script&lang=ts"
export * from "./JobSeekerDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__